/**
 * Le prix vit ici et nulle part ailleurs : la landing, la FAQ et le
 * récapitulatif de checkout doivent dire le même nombre que le prix Stripe.
 *
 * ⚠️ TVA — décision à confirmer par Stephen. Le prix Stripe est créé en
 * `tax_behavior: 'exclusive'` (199 € HT, TVA ajoutée au checkout, autoliquidation
 * pour les entreprises UE avec numéro de TVA). C'est volontaire : un prix laissé
 * en `tax_behavior: 'unspecified'` est traité comme TTC par Stripe et ampute le
 * net de 16,7 % sans que rien ne le signale dans le dashboard. Si Stephen veut
 * afficher 199 € TTC, il faut changer LES DEUX : `taxBehavior` ci-dessous et le
 * prix Stripe (un `tax_behavior` ne se modifie pas après coup, il faut un
 * nouveau prix).
 */
export const NEVERZERO_PRICE_AMOUNT = 199;
export const NEVERZERO_PRICE_CURRENCY = 'eur';
export const NEVERZERO_PRICE_LABEL = '€199';
export const NEVERZERO_PRICE_TAX_BEHAVIOR = 'exclusive';
